import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import _Button from "../../../../components/generic/_Button";
import { Table } from "../../../../components/ui/Table";
import { FormatInt } from "../../../../utils/FormatData";
import { useRCSError } from "../../hooks/useRCSError";
const formatHours = (value) => {
  const hour = Number(value);
  const period = hour < 12 ? "a.m." : "p.m.";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:00 ${period}`;
};
const columns = [
  {
    Header: "Carrier",
    accessor: "vc_carrier",
  },
  {
    Header: "Hora",
    accessor: "i_hour",
    Cell: (rowData) => {
      let value = rowData.row.original.i_hour;

      return formatHours(value);
    },
  },
  {
    Header: "Evento",
    accessor: "vc_event",
  },
  {
    Header: "Error",
    accessor: "vc_error",
  },
  {
    Header: "RCS",
    accessor: "i_rcs",
    Cell: (rowData) => {
      let value = rowData.row.original.i_rcs;

      return FormatInt(value);
    },
  },
  {
    Header: "Errores",
    accessor: "i_errors",
    Cell: (rowData) => {
      let value = rowData.row.original.i_errors;

      return FormatInt(value);
    },
  },
];

const _ModalRCSErrors = (props) => {
  const { visible = false, onClose, title = "" } = props;

  const { data, isPending: loading, isFetching } = useRCSError({visible});
  const _onClose = () => {
    if (onClose) onClose();
  };
  return (
    <Modal show={visible} onHide={_onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="text-xl font-semibold text-gray-600">{title}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          columns={columns}
          data={data}
          loading={loading || isFetching}
          config={{
            search: true,
            pageSize: 10,
            perPage: 10,
            pagination: true,
            rowInfo: false,
            navButtons: false,
            rowsPerPageSelection: false,
            footer: true,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <_Button
          title="Cerrar"
          style="primary"
          onClick={_onClose}
          loading={loading}
          disabled={loading}
        />
      </Modal.Footer>
    </Modal>
  );
};

_ModalRCSErrors.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  loading: PropTypes.bool,
};

export default _ModalRCSErrors;
